import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../../sass/Main";
import Card from "@material-ui/core/Card/index";
import CardActionArea from "@material-ui/core/CardActionArea/index";
import CardContent from "@material-ui/core/CardContent/index";
import CardMedia from "@material-ui/core/CardMedia/index";
import Typography from "@material-ui/core/Typography/index";
import { wizardCreateConnector, clearCreateConnectionState } from "../../../redux/actions/gettingStartedWizardActions";
import { pushMessage } from "../../../redux/actions/commonActions";
import { openURLInNewWindow } from "../../../common/utils";
import { buildBot, triggerCheckBotStatus } from "../../../redux/actions/intentsActions";
import {CircularProgress} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

class ConnectorVerticalCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      cardEnabled: true,
      cardLoading: false,
      connectionEstablished: false
     };
  }

  handleCardClick = async () => {
    const { pushMessage, wizardCreateConnector, buildBot, triggerCheckBotStatus } = this.props;
    this.setState({ 
      cardLoading: true 
    }); 

 /*    pushMessage({ type: "info", message: "Enabling new connector" }); */

    // These details are irrelevant since all users ATM will use the same app client;
    // the object is still passed to wizardCreateConnector in order to maintain backwards compatibility
    const newConnectorDetails = {
      connectorClientId: "blank",
      connectorClientSecret: "blank"
    };
    await wizardCreateConnector(newConnectorDetails, this.props.title, this.props.connector);
    await buildBot();
  };

  componentDidMount(){
    
    if(this.props.isConnected){
      this.setState({cardEnabled: false})
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // title is passed from the parent component, createdConnectorType is passed from redux
    const {
      title,
      createConnectionStatus,
      clearCreateConnectionState,
      createdConnectorType,
      pushMessage,
      connectorOauthRedirectUrl,
      connector,
      isConnected
    } = this.props;


    // Check if a new connector was created and if the new connector matches the current component prop
    if (createConnectionStatus && createdConnectorType === title) {
      clearCreateConnectionState();

      if (createConnectionStatus === 200) {
        // This is needed in the OAuth2Callback endpoint
        setTimeout(() => {
          localStorage.setItem("ConnectionId", connector.connectorName);
          this.setState({
            cardLoading: false
          })
          openURLInNewWindow(connectorOauthRedirectUrl);
        }, 200);
        
      } else {
        pushMessage({ type: "error", message: "Could not enable connector, please try again later" });
        this.setState({ cardEnabled: true });
      }
    }
  }

  /**
   * Return props which disable the action card area (ie the connector) if the connector is already enabled.
   * @return {{}|{disabled: boolean, style: {opacity: number}}}
   */
  getRemainingCardProps = () => {
    if (this.props.isConnected) {
      return { disabled: true, style: {borderTop: "3px solid #00cc51"} };
    }
    return {};
  };

  render() {
    const { classes, isConnected } = this.props;
    const { cardLoading } = this.state;


    return (
      <Card className={classes.signupCard} elevation={1}>
         <div className={classes.connectionIndicator}>
            {cardLoading&&<CircularProgress color="secondary" size={20} />}
            {isConnected&&<CheckCircleIcon style={{color:"#00cc51"}} />}
         </div>
        <CardActionArea onClick={this.handleCardClick} {...this.getRemainingCardProps()}>
          <CardMedia
            alt={this.props.title}
            className={classes.cardMedia}
            title={this.props.title}
            image={this.props.imgSrc}
          />
          <CardContent className={classes.cardContent}>
            <Typography gutterBottom variant="h5" component="h5">
              {this.props.title}
            </Typography>
          </CardContent> 
        </CardActionArea> 
      </Card>
    );
  }
}

const styledConnectorVerticalCard = withStyles(noHeaderCss)(ConnectorVerticalCard);

const mapStateToProps = state => {
  return {
    createConnectionStatus: state.gettingStartedWizard.createConnectionStatus,
    createdConnectorType: state.gettingStartedWizard.connectorType,
    connectorOauthRedirectUrl: state.gettingStartedWizard.oauthRedirectUrl
  };
};

export default connect(
  mapStateToProps,
  {
    pushMessage,
    wizardCreateConnector,
    clearCreateConnectionState,
    buildBot,
    triggerCheckBotStatus
  }
)(styledConnectorVerticalCard);
